import { render, staticRenderFns } from "./UiCards.vue?vue&type=template&id=1f572776&"
import script from "./UiCards.vue?vue&type=script&lang=js&"
export * from "./UiCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports